var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchTemplateFilters"},[_c('div',{staticClass:"searchTemplateFiltersTags"},[_vm._t("tagsLabel"),_vm._t("tagsList")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }